import {App, LayoutSections} from '@teemill/modules/app';
import {maxDevice} from '@teemill/common/helpers';
import {useWindowScroll} from '@vueuse/core';
import {computed} from 'vue';

const {y: scrollY} = useWindowScroll();

const theme = () => App.get('subdomain').theme;

export const searchConfig: LayoutSections = {
  announcement: {show: true},
  header: {
    show: true,
    fixed: true,
    overlay: false,
    width: 'container',
    height: computed(() => {
      if (maxDevice('md')) {
        return '3.5rem';
      }

      if (theme().get('menu.searchBar.show') === '1') {
        return '6.5rem';
      }

      if (scrollY.value === 0) {
        return '5rem';
      }

      return '4rem';
    }),
    logo: true,
    logoMaxWidth: '220px',
    centerLogo: () => maxDevice('md'),
    content: true,
    subContent: () =>
      !maxDevice('md') && theme().get('menu.searchBar.show') === '1',
  },
  sidebar: {
    show: () => maxDevice('md'),
    fixed: false,
    full: true,
    width: '220px',
  },
  content: {show: true, width: '1800px'},
  footer: {show: true},
  subFooter: {show: true},
  navBar: false,
};
